module.exports = "\r\n      <router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main